window.CNAM_FO = {
    nouvelleFenetreVers : "New Window to"
}